import { isEmpty } from "@/utils/lodash";
import * as types from "@/store/constants/types";
export default {
  [types.ROUTER_PUSH](state: any, payLoad: any) {
    console.log("ROUTER_PUSH:", payLoad);
    state.routeStack.unshift(payLoad);
  },
  [types.ROUTER_GO_BACK](state: any, payLoad: number) {
    try {
      console.log("ROUTER_GO_BACK:", payLoad);
      const pathNumber = Math.abs(payLoad);
      state.routeStack.splice(0, pathNumber);
    } catch (error) {
      console.log("ROUTER_GO_BACK error:", error);
    }
  },
  [types.ROUTER_REPLACE](state: any, payLoad: any) {
    console.log("ROUTER_REPLACE:", payLoad);
    try {
      //先删除第一个，再插入
      state.routeStack.shift();
      state.routeStack.unshift(payLoad);
    } catch (error) {}
  },
  [types.CHANGE_ROUTER_QUERY](state: any, payLoad: any) {
    const { index, routeName, mergeData } = payLoad;
    const { routeStack } = state;
    if (!isEmpty(index) && routeStack[index]) {
      const newRouter = {
        ...routeStack[index]
      };
      newRouter.query = {
        ...newRouter.query,
        ...mergeData
      };
      routeStack.splice(index, 1, newRouter);
    } else if (!isEmpty(routeName)) {
      const findIndex = routeStack.findIndex((route: any) => {
        return route.name === routeName;
      });
      if (findIndex !== undefined && findIndex > -1) {
        const newRouter = {
          ...routeStack[findIndex]
        };
        newRouter.query = {
          ...newRouter.query,
          ...mergeData
        };
        routeStack.splice(findIndex, 1, newRouter);
      }
    }
  }
};
